import React from 'react';
import { FieldError, useFormContext } from 'react-hook-form';
import cn from 'classnames/bind';
import styles from './field.module.css';

const cx = cn.bind(styles);

interface Props {
  name: string;
  label?: string;
  placeholder?: string;
  containerClassName?: string;
  error?: FieldError;
}

function TextAreaField({ name, label, placeholder, error, containerClassName }: Props) {
  const { register } = useFormContext();

  return (
    <div className={cx('container', containerClassName, { error })}>
      {label && (
        <label htmlFor={name} className={styles.label}>
          {label}
        </label>
      )}
      <div className={styles.fieldWrapper}>
        <textarea
          {...register(name)}
          placeholder={placeholder}
          id={name}
          className={cx('field', 'textarea') + ' ym-record-keys'}
        />
      </div>
      <span className={cx('errorText', { visible: error })}>{error?.message}</span>
    </div>
  );
}

export default TextAreaField;
